/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class BreakdownRoute extends Route {
  queryParams = {
    reportYear: {
      refreshModel: true,
      as: 'year',
    },
    reportType: {
      refreshModel: true,
      as: 'type',
    },
  };

  // Services
  @service
  store;

  model(params) {
    let group = this.modelFor('group');
    let includeFormer = this.modelFor('group.insights').includeFormer;

    return hash({
      group,
      learners: this.store.query('person', {
        groupId: group.id,
        include: 'enrolments',
        includeFormer,
      }),
      subject: this.store.findRecord('goals/subject', params.subject_id),
      levels: this.store.query('milestones/level', {
        goalSubjectId: params.subject_id,
      }),
      progressions: this.store.query('milestones/progression', {
        groupId: group.id,
        latest: true,
        type: ProgressionType.PROGRESSION,
        goalSubjectId: params.subject_id,
      }),
    });
  }

  afterModel(model, transition) {
    super.afterModel(...arguments);
    let query = transition.to.queryParams;
    this.controllerFor('group/insights/progress').setProperties({
      subjectId: model.subject.id,
      report: `${query.year}${query.type}`,
    });
  }
}
